import { Box, Button, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { supportEmail } from '@/constants/support';
import { useAuth } from '@/features/auth/contexts/auth-provider';

const LaunchErrorContent = () => {
  const { t } = useTranslation(['common']);
  const { logout } = useAuth();

  return (
    <Box>
      <Typography>{t('common:launchError.dueToTechnicalIssues')}</Typography>
      <Typography sx={{ mb: 2, textAlign: 'center' }}>
        {t('common:launchError.pleaseTryAgainLater')}
      </Typography>
      <Typography sx={{ mb: 3, textAlign: 'center' }}>
        {t('common:launchError.problemPersist')}
        <Link href={`mailto:${supportEmail}`}>{supportEmail}</Link>
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
        <Button variant="outlined" onClick={logout}>
          {t('common:logout')}
        </Button>
        <Button variant="contained" onClick={() => window.location.reload()}>
          {t('common:launchError.retry')}
        </Button>
      </Box>
    </Box>
  );
};

export default LaunchErrorContent;
